export enum Module {
  ALERT = "active_alerts",
  BOOKING = "booking",
  DASHBOARD = "dashboard",
  HELICOPTER = "cockpit",
  PRICING = "pricing",
  EVENT = "events",
  GROUP_QUOTATION = "group_quotation",
  CONFIGURATION = "react_configuration",
}
